import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=340d6135&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340d6135')) {
      api.createRecord('340d6135', component.options)
    } else {
      api.reload('340d6135', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=340d6135&", function () {
      api.rerender('340d6135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFT108M4dzlD/JS/comp/childrenage.vue"
export default component.exports